module.exports = __webpack_public_path__ + "static/media/questions.c7090ab1.png";